import { RulesLogic } from 'json-logic-js';

import { useApply } from 'inquiry/lib/jsonLogic';
import { GovernmentIdNfcScanComponent, ParentComponentProps } from 'lib/interfaces/ui-components';
import { HolderClient } from 'verify/lib/clients/HolderClient';
import { UiComponentActionsApi } from 'verify/lib/interfaces/uiComponent';
import { Inquiry } from 'verify/models/inquiry';

import Button, { ButtonType } from '../Button';

interface GovernmentIdNfcScanProps extends ParentComponentProps {
  component: GovernmentIdNfcScanComponent;
  inquiry: Inquiry;
  actionsApi: UiComponentActionsApi;
  inquiryLoading: boolean;
}

const GovernmentIdNfcScan = ({ component, inquiry }: GovernmentIdNfcScanProps) => {
  const { hidden, 'launch-button-text': launchButtonText } = component.attributes;

  const apply = useApply(component.name, inquiry.attributes['next-step'].name);
  const isHidden = apply<boolean>(hidden as RulesLogic | null);

  if (isHidden) {
    return null;
  }

  // in FLE, we don't disable it, otherwise it is disabled since we can't scan on web
  const isDisabled = !HolderClient.isDashboardFLE;

  // TODO: Add inputs for document number, DoB, expiration date
  return (
    <>
      <Button
        id='government_id_nfc_scan__button_submit'
        type='submit'
        buttonType={ButtonType.Primary}
        disabled={isDisabled}
        styles={component?.styles?.['button-primary-style']?.base?.base}
      >
        {launchButtonText || 'Start scan'}
      </Button>
    </>
  );
};

export default GovernmentIdNfcScan;
